import FormInput from './FormInput.vue'
import FormSelect from './FormSelect.vue'
import FormRadio from './FormRadio.vue'
import FormCheckbox from './FormCheckbox.vue'
import FormButton from './FormButton.vue'

// 字段类型映射
export const formTypes = {
  "tm-input": FormInput,
  "tm-select": FormSelect,
  "tm-radio": FormRadio,
  "tm-checkbox": FormCheckbox,
  "tm-button": FormButton,
}

// 导出所有字段组件
export {
  FormInput,
  FormSelect,
  FormRadio,
  FormCheckbox,
  FormButton
}

// 安装函数
const install = function(Vue) {
  if (install.installed) return
  install.installed = true
  
  // 注册所有字段组件
  Vue.component(FormInput.name, FormInput)
  Vue.component(FormSelect.name, FormSelect)
  Vue.component(FormRadio.name, FormRadio)
  Vue.component(FormCheckbox.name, FormCheckbox)
  Vue.component(FormButton.name, FormButton)
}

// 自动安装
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  formTypes
} 